module.exports = __webpack_public_path__ + "static/img/icon_my_calendar.b2c3285.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_my_calendar.svg
// module id = Dr6M
// module chunks = 10